(function (){
    'use strict';
    angular.module('app').controller('AssignPromoCodeContrller',AssignPromoCodeContrller);
    AssignPromoCodeContrller.$Inject=[
        'data',
        'AffiliateService',
        'ClientService',
        '$routeParams',
        '$filter',
        '$uibModalInstance',
        'toastr'
    ];

    function AssignPromoCodeContrller(data,AffiliateService,ClientService,$routeParams,$filter,$uibModalInstance,toastr){
        const vm  = this;
        vm.promoCode =  angular.copy(data)
        vm.company = {};
        vm.subAffiliates = [];
        vm.modalClose = modalClose;
        vm.getClientCompany = getClientCompany;

        vm.onSubmit = function(form){
           
            if(form.$valid){
                assignPromocode();
            }
           
        }

        init();
        function init(){
            getSubAffiliateDetails();
            getClientCompany();
            getReferrer();
        }

        function modalClose(){
            $uibModalInstance.dismiss();
        }

        function getSubAffiliateDetails(){
            AffiliateService.subAffiliateDetails(data.id,
                res=>{
                    res.forEach(sub => {
                        sub.userMarketing.fullname = `${sub.userMarketing.firstName} ${sub.userMarketing.lastName}`;
                        vm.subAffiliates.push({owner:sub.userMarketing,commission:sub.commissionPercent})
                    });
                    vm.referrer = vm.subAffiliates
                },
                err=>{
                    console.log(err)
                });
        }

        function assignPromocode(){
            vm.loading = true;
            
            if(!vm.promoCode.active){
                toastr.error('Inactive Promocode cannot be Assigned.');
                vm.loading = false;
                return;
            }
            const payload = cleanPayload(vm.promoCode);
            AffiliateService.createCompanyReferred(
                res=>{
                    toastr.success('Successfully Assign Promo Code!');
                    vm.loading = false;
                    $uibModalInstance.close(true)
                },
                err=>{
                    toastr.error(err.message);
                    vm.loading = false;
                },payload
            )
        }

        function cleanPayload(data){
            const payload ={};
            const companyIds =[];
            data.companyMarketing.forEach(company => {
                companyIds.push(company.id)
            });
            payload.promoCodeId= vm.promoCode.id
            payload.companyIds = companyIds
            return payload;
        }

        function getClientCompany(data){
            ClientService.Company.getAll(
                res=>{
                    vm.companies = res.content 
                },  
                err=>{
                    toastr.error(err.message);
                },
                {
                    name: data,
                    size:1000
                }
            )
        }

        function getReferrer(){
            AffiliateService.getUserMarketing(res=>{
                res.content.forEach(item => {
                    item.fullname = `${item.firstName} ${item.lastName}`
                });
                vm.marketingList = res.content
            },err=>{
                console.log(err);
            },{
                size:500,
                companyMarketingId:$routeParams.id
            })
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/modal/assignPromoCodeController.js